<template>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="d-flex align-items-center mb-3">
        <h1 class="h3 mb-0 me-auto">Kam greš?</h1>
        <router-link :to="{ name: 'Home' }" class="btn btn-sm btn-outline-secondary">Pozneje</router-link>
      </div>
      <NextDestination @declared="router.push({ name: 'Home' })" />
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router"
import NextDestination from "../components/NextDestination.vue"

// shown after an SDN is signed, and from the home page
defineOptions({ name: "NextDestinationView" })

const router = useRouter()
</script>
